//whitelisted affiliates for the fraud report.   (verified non-bad actors)

export const whitelistedAffs = [
	361589, 361673, 360061, 361441, 363869, 361705, 362257, 361693, 361797,
	362293, 361669, 361461, 362133, 363037, 363905, 364021, 361429, 360137,
	364277, 353473, 329573, 343585, 327897, 318893, 320873, 350829, 351049,
	314393, 329525, 339649, 355925, 318793, 316461, 338561, 317313, 340201,
	315657, 317049, 318529, 324265, 338193, 361169, 347801, 306881, 309809,
	332057, 361293,
];
